import script from "./AuthOverlays.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthOverlays.vue?vue&type=script&setup=true&lang=ts"

import "./AuthOverlays.vue?vue&type=style&index=0&id=ba82af66&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba82af66"]])

export default __exports__